<template>
  <div :id="localId"></div>
</template>

<script>
import mx_Core from './includes/mixins/zMixins'        

export default {
  name: "j-chart-summary-table",
  mixins: [mx_Core],
  props: {
    id: String,
    ChartType: String,

    FilterValues: { type: Object, default: () => ({}) },
    ColumnProps:  { type: Array, default: () => ([]) },
    Database:     { type: Object, default: () => ({}) },
    Canvas:       { type: Object, default: () => ({}) },
    Common:       { type: Object, default: () => ({}) },
    CTypes:       { type: Object, default: () => ({}) },
    DataCols:     { type: Object, default: () => ({}) },
    DataItems:    { type: Array, default: () => ([]) },
    Text:         { type: Object, default: () => ({}) },
  },
  created() {
    this.localId = `${this.id || 'j-chart-summary-table'}__${this.safeId('')}`
  },
  mounted() {
    this.register(this.draw)
  },
  methods: {
    draw() {
      if (!this.ready2draw) {
        return
      }
      this.clear()
      this.set_LocalValues()
      this.drawCanvas()
      // this.drawNotes()
      this.drawTexts()
      this.drawing()  
      this.complete()
    },

    drawing() {
      this.draw_Forms()
    },
  }
}
</script>